export default __webpack_public_path__ + "static/media/CNo.51-1.6f52a679.jpg";